export default {
  TITLE_DOSE_NOT_EXIST: "عنوان وارد نشده است.",
  TITLE_INVALID: "عنوان نامعتیر است.",

  PATTERN_DOSE_NOT_EXIST: "الگو وارد نشده است.",
  PATTERN_INVALID: "الگو نامعتیر است.",
  
  ACTIVE_INVALID: "فعال بودن نامعتبر است.",
  
  LINK_DOSE_NOT_EXIST: "لینک وارد نشده است.",
  LINK_INVALID: "لینک نامعتیر است.",

  PRICE_DOSE_NOT_EXIST: "قیمت وارد نشده است.",
  PRICE_INVALID: "قیمت نامعتیر است.",
};
